module.exports = __webpack_public_path__ + "img/milk_tea.8e82d2c3.png";